<template>
	<div class="p-grid irinox-form">
    <div class="p-col-12 p-pt-1 p-pb-1 p-d-flex p-jc-between p-ai-center">
      <p>{{ $t('afterSales.tab_documents') }}</p>
      <div class="search-bar">
        <i class="pi pi-search" />
        <InputText v-model="filters.search" :placeholder="$t('afterSales.search_document_ph')" :aria-label="$t('afterSales.search_document_ph')"/>
        <i class="pi pi-times" @click="function() {filters.search=null}"/>
      </div>
    </div>
    <div v-if="documents.length === 0" class="p-col-12 p-p-3 p-text-center">
      <div class="p-mt-5 p-mb-5">
        <i class="pi pi-info-circle" style="font-size: 2em; color: var(--irx-color-secondary)"></i>
      </div>
      <div class="p-mb-5" style="font-size: 1.2em; color: var(--irx-color-secondary)">
        {{ $t('afterSales.documents_empty_list') }}
      </div>
    </div>
    <div v-else class="p-col-12 p-md-5">
      <h5>{{ $t('afterSales.categories') }}</h5>

      <div class="cat-list">
        <div class="cat-item" v-for="(docs, cat) in categories" :key="cat" @click="changeCategory(cat)" :class="{'cat-item-selected': filters.category === cat}">
          <div :class="filters.category === cat ? 'icon-afterSales_folder_open' : 'icon-afterSales_folder_closed'" style="font-size: 16px; margin-left: 20px;"/>
          <div class="cat-item-label">{{ $t(`afterSales.category.${cat}`) }}</div>
          <Badge :value="categoriesFiltered[cat]?.length ?? '0'"></Badge>
          <i class="pi pi-angle-right"></i>
        </div>
      </div>
    </div>

    <div class="p-col-12 p-md-7" v-if="filters.category != null">
      <h5>{{ $t(`afterSales.category.${filters.category}`) }}</h5>

      <div class="lang-filter">
        <SelectButton  id="add_dialog_role" v-model="filters.lang" :options="availableLangs" 
            multiple  optionDisabled="disabled" />
      </div>

      <div class="doc-list">
        <div class="doc-item" v-for="(doc, index) in documentsFiltered" :key="index" @click="openDocument(doc)" :class="{'distribution-not-visible':!doc.distributions.includes('machine_dashboard') && !doc.distributions.includes('generic_section')}">
          <!-- <img v-if="doc.type === 'FILE'" src="assets/irinox/icons/afterSales_pdf.svg" :alt="doc.type" width="25" />
          <img v-else src="assets/irinox/icons/afterSales_video.svg" :alt="doc.type" width="25" /> -->
          <i v-if="doc.type === 'FILE'" :class="['pi', $functions.documentIcon(doc.externalRef)]" />
          <i v-else :class="['pi', $functions.linkIcon(doc.externalRef)]" />

          <div class="doc-item-label">{{ doc.title }}</div>
          
          <i v-if="role==='INTERNAL_DOC' || role.includes('FACTORY')" class="icon-edit" @click.stop="updateDialog(doc)" style="color: #808080;"/>

          <img v-if="langs[doc.lang]?.flag" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + langs[doc.lang].flag" width="30" :alt="doc.lang"/>

          <div v-if="doc.lang=='MULTI'" style="width: 110px">{{ $t('afterSales.lang_MULTI')}}</div>
          <div v-else style="width: 70px">{{ doc.lang }}</div>

          <!-- <img src="assets/irinox/icons/share.svg" :alt="doc.fileType"  height="15"/> -->

        </div>
      </div>
    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error"
    mode="error"
    :message="$t('details.dialog_error')"
    :life="3000"
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.success"
    mode="success"
    :message="$t('afterSales.download_doc_success')"
    :life="3000"
    @update:visible="dialog.success = $event" />

  <SearchDocumentEdit
    :visible="dialog.editDocument"
    :documentId="edit.documentId"
    :title="edit.title"
    :access="edit.access"
    :distributions="edit.distributions"
    @update:visible="dialog.editDocument = $event"
    @saved:document="documentSaved"/>
</template>

<script>
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import SearchDocumentEdit from './SearchDocumentEdit.vue';
import { mapGetters } from 'vuex';
import {FilterService} from 'primevue/api';
export default {
  components: {
    IrinoxDialogDark,
    SearchDocumentEdit
  },
  emits: ['refresh'],
  props: {
    documents: {
      type: Array,
      required: true
    },
    docTreeId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      langs: this.$functions.documentLanguages(),
      dialog: {
        error: false,
        success: false,
        editDocument: false,
      },
      filters: {
        category: null,
        lang: [],
        search: null,
      },
      edit: {
        documentId: null,
        title: null,
        access: null,
        distributions: []
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      role: 'userdata/role',
    }),
    categories() {
      let cats = {};
      this.documents.forEach(doc => {
        if(!cats[doc.category]) {
          cats[doc.category] = [];
        }
        cats[doc.category].push(doc);
      });
      return cats;
    },
    categoriesFiltered() {
      let cats = {};
      this.documents.forEach(doc => {
        if(this.filters.search==null || FilterService.filters.contains(doc.title, this.filters.search)) {
          if(!cats[doc.category]) {
            cats[doc.category] = [];
          }
          cats[doc.category].push(doc);
        }
      });
      return cats;
    },
    documentsFiltered() {
      let temp = [];
      this.documents.forEach(doc => {
        let s = this.filters.search==null || FilterService.filters.contains(doc.title, this.filters.search);
        let l = this.filters.lang.length === 0 || doc.lang=='MULTI' || this.filters.lang.includes(doc.lang);
        let c = this.filters.category==null || doc.category === this.filters.category;
        if(s && l && c) {
          temp.push(doc);
        }
      });
      return temp;
    },
    availableLangs() {
      let temp = [];
      this.documents.forEach(doc => {
        let s = this.filters.search==null || FilterService.filters.contains(doc.title, this.filters.search);
        let c = this.filters.category==null || doc.category === this.filters.category;
        if(s && c) {
          temp.push(doc);
        }
      });
      let langs = [];
      temp.forEach(doc => {
        if(!langs.includes(doc.lang) && doc.lang!='MULTI') {
          langs.push(doc.lang);
        }
      });
      return langs.sort();
    }
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
  },
  methods: {
    changeCategory(cat) {
      this.filters.category = cat;
      this.filters.lang = [];
    },
    openDocument(doc) {
      // Logic to open the document
      this.afterSalesService.docAuditLog(this.personaltoken, doc.documentId).catch(error => { console.error("AUDIT EXCEPTION "+error); });
      if(doc.type === 'FILE') {
        this.download(doc);
      } else if(doc.type === 'LINK' && doc.externalRef) {
        window.open(doc.externalRef, '_blank');
      }
    },
    download(doc) {
        this.afterSalesService.downloadDocument(doc.externalRef)
          .then((res) => {
            let contentType = res.headers["content-type"];
            if(contentType !== 'application/json') {
              let filename = doc.title;
              try {
                const url = new URL(doc.externalRef);
                const decodedPath = decodeURIComponent(url.pathname);
                const parts = decodedPath.split('/');
                const last = parts[parts.length - 1];
                if (last) filename = last;
              } catch (e) { /* keep doc.title as fallback */ }
              this.dialog.success = true;
              let blob=new Blob([res.data], {type: contentType});
              let link=document.createElement('a');
              link.href=window.URL.createObjectURL(blob);
              link.download=filename;
              link.click();
            } else {
              console.error("EXCEPTION "+JSON.stringify(res));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
    updateDialog(doc) {
      this.edit.documentId = doc.documentId;
      this.edit.title = doc.title;
      this.edit.access = doc.access;
      this.edit.distributions = doc.distributions;
      this.dialog.editDocument = true;
    },
    documentSaved() {
      this.dialog.editDocument = false;
      this.$emit('refresh');
    }
  }
}

</script>

<style scoped>
</style>